// Подключаемая вёрстка

export default (
	{
		cls,
		min = 0,
		max = null,
		stepSize = 1,
		float = 0,
		roundByStep = false,
		value = '',
		disabled = false,
		attrs = {},
		inputAttrs = {},
	} = {}) => [
		{block: 'counter', cls,
			attrs: {
				'data-min': min,
				'data-max': max,
				'data-step-size': stepSize,
				'data-float': float,
				'data-round-by-step': roundByStep,
				...attrs
			},
			content: [
				{elem: 'control', tag: 'button', mods: {minus: true}, attrs: {type: 'button', 'data-control-minus': true}},
				{elem: 'input', tag: 'input',
					attrs: {
						placeholder: '0',
						...inputAttrs,
						value,
						disabled,
						'data-inputmask': '"alias": "numeric", "rightAlign": false, "SetMaxOnOverflow": true',
					},
				},
				{elem: 'control', tag: 'button', mods: {plus: true}, attrs: {type: 'button', 'data-control-plus': true }},
			],
		},
];
